import Plyr from 'plyr';


class VideoPlayer extends HTMLElement {
  constructor() {
    super();
    this.init();
  }
  init() {
    this.videoContainer = this.querySelector(".player");
    const videoPlayer = new Plyr(this.videoContainer);
    if(this.dataset.poster) {
      videoPlayer.poster = this.dataset.poster;
    }
    const _this = this;
    videoPlayer.on('ended', (event) => {
      _this.querySelector('.plyr').classList.add('plyr--stopped')
    });
    // videoPlayer.play();
  }
}
customElements.define("video-player", VideoPlayer);